export { default as formatDate } from './dates/format-date';
export { default as parseDate } from './dates/parse-date';
export { default as splitDateFormat } from './dates/split-date-format';



//////////////////
// WEBPACK FOOTER
// ./~/@telerik/kendo-intl/dist/es/dates.js
// module id = 394
// module chunks = 93